import { Component, Input, OnInit } from '@angular/core';
import {
  characterSpecialityType,
  ICharacterSpeciality,
} from 'src/app/api/interfaces/character.interface';

@Component({
  selector: 'app-progress-bar-with-level',
  templateUrl: './progress-bar-with-level.component.html',
  styleUrls: ['./progress-bar-with-level.component.scss'],
})
export class ProgressBarWithLevelComponent implements OnInit {
  @Input() type: characterSpecialityType | string | 'ENERGY' = 'FISHERMAN';
  @Input() level: number | undefined;
  @Input() energy: number | undefined;
  @Input() progress: number = 0;
  @Input() previewProgress: number | undefined;
  @Input() previewExp: number | undefined;
  @Input() smallProgressScale: boolean | undefined;
  constructor() {}

  ngOnInit(): void {}
}
